import React from 'react';
import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../auth/useAuth';
import { logger } from '../../utils/logger';
import './Unauthorized.css';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { oktaAuth, authState } = useAuth();

  // Check if the error is due to unauthorized domain
  const authError = sessionStorage.getItem('auth_error');
  const isUnauthorizedDomain = authError === 'unauthorized_domain';

  // If the user is already authenticated, they were redirected here due to
  // insufficient role (e.g. READ_USER trying to access /update or /onboard)
  const isAuthenticated = authState?.isAuthenticated === true;

  const handleBackToHome = () => {
    navigate('/', { replace: true });
  };

  const handleBackToLogin = async () => {
    // Set flag before clearing to indicate we're returning from unauthorized
    sessionStorage.setItem('returning_from_unauthorized', 'true');
    // Clear other stored session data
    sessionStorage.removeItem('auth_error');
    sessionStorage.removeItem('login_hint');

    // Clear Okta session to allow fresh login
    try {
      await oktaAuth.signOut({
        postLogoutRedirectUri: window.location.origin + '/login',
        clearTokensBeforeRedirect: true,
      });
    } catch (err) {
      logger.warn('Error signing out', { error: (err as Error).message });
      // Even if signout fails, navigate to login
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="unauthorized-container">
      <Result
        status="403"
        icon={<LockOutlined style={{ fontSize: 72, color: '#ff4d4f' }} />}
        title="Unauthorized Access"
        subTitle={
          isUnauthorizedDomain
            ? "Only users with @cisco.com email addresses are authorized to access this application. Please contact your administrator if you believe this is an error."
            : "You do not have permission to access this page. Please contact your administrator if you believe this is an error."
        }
        extra={
          isAuthenticated ? (
            <Button type="primary" size="large" onClick={handleBackToHome}>
              Back to Home
            </Button>
          ) : (
            <Button type="primary" size="large" onClick={handleBackToLogin}>
              Back to Login
            </Button>
          )
        }
      />
    </div>
  );
};

export default Unauthorized;
